import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import ReactSelect from 'react-select';
import { Modal } from 'reactstrap';
import * as pageControllerActions from '../redux/pageControllerActions';
import {
  actionProjectAndFolderSaveWasClicked,
  setWebLinkSaveFolderType,
  setWebLinkSaveDialogue,
  setFolderForWebLink
} from '../redux/projectSaveAndLoader';

import * as finalCheckActions from '../redux/finalCheckActions';
import './ExternalLinkSaveProject.scss';
import * as Constants from '../utilities/constants/Constants';
import { string } from '../localization';
import * as CookieUtils from '../utilities/CookieUtils/CookieUtils';

class ExternalLinkSaveProject extends Component {
  state = {
    foldersArray: [],
    folderName: '',
    inputProjectName: '',
    folderError: false,
    projectError: false
  };

  componentDidMount() {
    const { selectedFolder, projectName } = this.props;
    this.setState({
      folderName: selectedFolder,
      inputProjectName: projectName
    });
  }

  handleInputChange = (e, name) => {
    const { dispatchers } = this.props;
    if (name === 'projectName') {
      this.setState({ inputProjectName: e.target.value });
    } else {
      this.setState({ folderName: e.target.value });
      dispatchers.setFolderForWebLink(e.target.value);
    }
  };

  handleFolderSelection = folderType => {
    const { dispatchers } = this.props;
    this.setState({ folderName: '' });
    dispatchers.setWebLinkSaveFolderType(folderType);
  };

  handleClose = () => {
    const { dispatchers } = this.props;
    dispatchers.setWebLinkSaveDialogue(false);
    this.checkForWeblinkCookie();
  };

  checkForWeblinkCookie = () => {
    const cookie = CookieUtils.resumeActivityCookieActivity();
    const documentColorsCookie = CookieUtils.resumeDocumentColorsCookieActivity();
    if (
      cookie &&
      (cookie === Constants.WEBLINK_CHECKOUT_ACTIVITY ||
        cookie === Constants.WEBLINK_SAVE_ACTIVITY)
    ) {
      CookieUtils.removeActivityCookie();
      if (documentColorsCookie !== null) {
        CookieUtils.removeDocumentColorsCookie();
      }
    }
  };

  saveProject = () => {
    const { dispatchers } = this.props;
    const { folderName, inputProjectName } = this.state;
    const isValidProjectFolder = dispatchers.fabricCanvasActions.projectFolderValidation(
      folderName
    );
    const isValidProjectName = dispatchers.fabricCanvasActions.projectNameValidation(
      inputProjectName
    );

    if (isValidProjectFolder && folderName !== '') {
      this.setState({ folderError: false });
      dispatchers.setFolderForWebLink(folderName);
    } else {
      this.setState({ folderError: true });
    }

    if (isValidProjectName) {
      this.setState({ projectError: false });
      dispatchers.finalCheckActions.setProjectName(inputProjectName);
    } else {
      this.setState({ projectError: true });
    }

    if (isValidProjectFolder && folderName !== '' && isValidProjectName) {
      // need to be optimised

      dispatchers.actionProjectAndFolderSaveWasClicked().then(() => {
        this.continueSaving();
      });
      dispatchers.setWebLinkSaveDialogue(false);
    }
  };

  continueSaving = () => {
    const {
      sendPreviewWithLoupe,
      webLinkSaveIdentifier,
      dispatchers
    } = this.props;
    if (
      sendPreviewWithLoupe &&
      webLinkSaveIdentifier === Constants.DESIGN_KEY
    ) {
      dispatchers.fabricCanvasActions.handleRequestSample();
    }
    if (webLinkSaveIdentifier === Constants.FINAL_CHECK_KEY) {
      dispatchers.pageControllerActions.setCurrentPageIndex(
        Constants.FINAL_CHECK_PAGE
      );
    }
  };

  render() {
    const {
      rootFolders,
      selectedFolder,
      projectName,
      shareMedium,
      webLinkSaveDialogue,
      folderType
    } = this.props;
    const {
      foldersArray,
      projectError,
      folderError,
      folderName,
      inputProjectName
    } = this.state;

    if (rootFolders.length > 0 && foldersArray.length == 0) {
      const folders = [];
      rootFolders.forEach(folder => {
        const newDict = {};
        newDict.value = folder;
        newDict.label = folder;
        folders.push(newDict);
      });
      this.setState({ foldersArray: folders });
    }

    let defaultSelectedFolder = foldersArray.filter(
      f => f.value === selectedFolder
    );

    if (defaultSelectedFolder.length === 0) {
      if (folderName != '') {
        defaultSelectedFolder = { value: folderName, label: folderName };
      } else if (foldersArray.length > 0) {
        [defaultSelectedFolder] = foldersArray;
        this.setState({ folderName: defaultSelectedFolder.label });
        this.setState({
          inputProjectName: projectName
        });
      }
    }

    const folderClass = folderError ? 'error-border-save' : 'normal-border';
    const projectClass = projectError ? 'error-border-save' : 'normal-border';

    let errorField = '';
    if (folderError) {
      if (folderName === '') {
        errorField = string.PROJECT_FOLDER_ERROR_TEXT;
      } else {
        errorField = string.NONUNIQUE_FOLDER_NAME_MESSAGE;
      }
    } else if (projectError) {
      if (inputProjectName === '') {
        errorField = string.PROJECT_NAME_ERROR_TEXT;
      } else {
        errorField = string.NONUNIQUE_PROJECT_NAME_MESSAGE;
      }
    }

    let header1 = string.SAVE_DIALOG_TITLE;
    let header2 = string.GIVE_PROJECT_NAME_KEY;
    let okButton = string.FINISH_KEY;
    if (shareMedium !== null) {
      header1 = string.ORDER_SAMPLE;
      header2 = string.SAVE_PROJECT_NAME_KEY;
      okButton = string.CONTINUE_KEY;
    }

    return (
      <div>
        <Modal isOpen={webLinkSaveDialogue} className='modal-order-sample'>
          <div className='external-link-project-save'>
            <div className='titleOrderSample'>{header1}</div>
            <p className='saveProjectTxt'>{header2}</p>
            <div className='radio-button-container'>
              <div className='pt-2 mr-1'>
                <input
                  type='radio'
                  name='folder-type'
                  onClick={() =>
                    this.handleFolderSelection(Constants.EXISTING_FOLDER_TYPE)
                  }
                  checked={folderType === Constants.EXISTING_FOLDER_TYPE}
                />
                <span className='labelTxt'>{string.EXISTING_FOLDER_KEY}</span>
              </div>
              <div className='pt-2 mr-1'>
                <input
                  type='radio'
                  name='folder-type'
                  onClick={() =>
                    this.handleFolderSelection(Constants.NEW_FOLDER_TYPE)
                  }
                  checked={folderType === Constants.NEW_FOLDER_TYPE}
                />
                <span className='labelTxt'>{string.NEW_FOLDER_KEY}</span>
              </div>
            </div>
            {folderType === Constants.NO_FOLDER_TYPE ? null : (
              <div className='pt-3 input-container'>
                <span className='input-label'>{string.FOLDER_NAME_KEY}</span>
                {folderType === Constants.NEW_FOLDER_TYPE ? (
                  <div className={folderClass}>
                    <input
                      type='text'
                      className='input'
                      value={folderName}
                      placeholder={string.FOLDER_NAME}
                      style={{
                        marginTop: '5px',
                        marginBottom: '5px',
                        marginRight: '5px'
                      }}
                      onChange={(e, name = 'folderName') =>
                        this.handleInputChange(e, name)
                      }
                    />
                  </div>
                ) : (
                  <ReactSelect
                    id='react-select-shadow-dropdown'
                    value={defaultSelectedFolder}
                    options={foldersArray}
                    onChange={(e, name = 'folderName') => {
                      this.handleInputChange({ target: e }, name);
                    }}
                    styles={{
                      control: base => ({
                        ...base,
                        '&:hover': { borderColor: 'gray' },
                        border: '1px solid rgb(128, 128, 128)',
                        borderRadius: '4px',
                        boxShadow: 'none',
                        background: 'none',
                        color: '#000',
                        width: '224px'
                      }),
                      option: provided => ({
                        ...provided,
                        color: '#000',
                        padding: '5px',
                        fontWeight: 'bold'
                      }),
                      singleValue: base => ({
                        ...base,
                        color: 'black'
                      })
                    }}
                  />
                )}
              </div>
            )}
            <div className='pt-2 input-container'>
              <span className='input-label'> {string.PROJECT_NAME} </span>
              <div className={projectClass}>
                <input
                  type='text'
                  className='input'
                  value={inputProjectName}
                  placeholder={string.PROJECT_NAME_KEY}
                  onChange={(e, name = 'projectName') =>
                    this.handleInputChange(e, name)
                  }
                />
              </div>
            </div>
            {projectError || inputProjectName ? (
              <div
                style={{
                  fontFamily: 'HPSimplifiedLight, Arial, sans-serif',
                  color: 'red',
                  marginTop: '5px',
                  marginBottom: '5px'
                }}
              >
                {errorField}
              </div>
            ) : null}
            <div className='d-flex buttonContainer'>
              <button
                type='button'
                className='cancelBtn'
                onClick={this.handleClose}
              >
                {string.CANCEL_TEXT_KEY}
              </button>
              <button
                type='button'
                className='continueBtn'
                onClick={this.saveProject}
              >
                {okButton}
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    webLinkSaveDialogue: state.fabricCanvas.webLinkSaveDialogue,
    selectedFolder: state.fabricCanvas.selectedFolderForWebLink,
    folderType: state.fabricCanvas.webLinkSaveFolderType,
    rootFolders: state.fabricCanvas.rootFolders,
    projectName: state.finalCheck.project.name,
    webLinkSaveIdentifier: state.fabricCanvas.webLinkSaveIdentifier,
    envData: state.modal.envData,
    shareMedium: state.fabricCanvas.shareMedium,
    sendPreviewWithLoupe: state.fabricCanvas.sendPreviewWithLoupe
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      actionProjectAndFolderSaveWasClicked: bindActionCreators(
        actionProjectAndFolderSaveWasClicked,
        dispatch
      ),
      setWebLinkSaveFolderType: bindActionCreators(
        setWebLinkSaveFolderType,
        dispatch
      ),
      setWebLinkSaveDialogue: bindActionCreators(
        setWebLinkSaveDialogue,
        dispatch
      ),
      setFolderForWebLink: bindActionCreators(setFolderForWebLink, dispatch),
      finalCheckActions: bindActionCreators(finalCheckActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalLinkSaveProject);
